import React from 'react'

export default function Menu() {
    return (
        <div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 16.75C22 16.336 21.664 16 21.25 16H2.75C2.336 16 2 16.336 2 16.75C2 17.164 2.336 17.5 2.75 17.5H21.25C21.664 17.5 22 17.164 22 16.75ZM22 11.75C22 11.336 21.664 11 21.25 11H2.75C2.336 11 2 11.336 2 11.75C2 12.164 2.336 12.5 2.75 12.5H21.25C21.664 12.5 22 12.164 22 11.75ZM22 6.75C22 6.336 21.664 6 21.25 6H2.75C2.336 6 2 6.336 2 6.75C2 7.164 2.336 7.5 2.75 7.5H21.25C21.664 7.5 22 7.164 22 6.75Z" fill="black" />
            </svg>
        </div>
    )
}
